<template>
  <div class="app-container dashboard-container">
    hello,dashboard
  </div>
</template>

<script>
export default {
  name: "Dashboard",
  data() {
    return {};
  },
  mounted() {
    this.getOverviewStatisFun();
  },
  methods: {
    getOverviewStatisFun() {}
  }
};
</script>

<style lang="scss" scoped>
.dashboard-container {
}
</style>
